document.addEventListener('DOMContentLoaded', () => {
  const slideshowContent = document.querySelectorAll('.ds-collection-card__image');
  if (slideshowContent) {
    slideshowContent.forEach(item => {
      item.addEventListener('mouseover', (event) => {
        event.preventDefault();
        item.classList.add('visible');
      });

      item.addEventListener('mouseout', (event) => {
        event.preventDefault();
        item.classList.remove('visible');
      });
    });
  }
});